if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[name="add"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Add failed');

        // Open cart drawer (Dawn way)
        const drawer = document.querySelector('cart-drawer') || document.querySelector('#cart-drawer');
        if (drawer) {
          drawer.openDrawer ? drawer.openDrawer() : drawer.classList.add('is-open'); // fallback
          // Force section render update
          await fetch(`${window.location.pathname}?section_id=cart-drawer`)
            .then(r => r.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              document.querySelector('#cart-drawer')?.replaceWith(doc.querySelector('#cart-drawer'));
            });
        }

        submitBtn.textContent = 'Added ✓';
        setTimeout(() => { submitBtn.textContent = 'Add to Cart'; submitBtn.disabled = false; }, 2000);

      } catch (err) {
        console.error(err);
        submitBtn.textContent = 'Error';
        setTimeout(() => { submitBtn.textContent = 'Add to Cart'; submitBtn.disabled = false; }, 2000);
      }
    });
  });

  // Quantity +/- buttons
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const input = e.target.parentElement.querySelector('.quantity-input');
      let val = parseInt(input.value);
      if (e.target.classList.contains('minus') && val > 1) val--;
      if (e.target.classList.contains('plus')) val++;
      input.value = val;
    });
  });

  // Variant change updates hidden id
  document.querySelectorAll('.selector').forEach(select => {
    select.addEventListener('change', (e) => {
      const form = e.target.closest('form');
      const masterIdInput = form.querySelector('.variant-id-input');
      // Simple fallback: on change re-select first available or use Shopify's logic
      // For full sync, include product-variants.liquid or use pickupAvailability logic
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.quick-add-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('.add-btn');
      btn.disabled = true;
      btn.textContent = 'Adding...';

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error();

        // Open drawer (Dawn method)
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open();

        // Brief success feedback
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);

        // Optional: dispatch event for other updates
        document.dispatchEvent(new CustomEvent('cart:updated'));

      } catch (err) {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
      }
    });

    // Quantity +/- 
    form.querySelectorAll('.qty-minus, .qty-plus').forEach(btn => {
      btn.addEventListener('click', e => {
        const input = form.querySelector('.qty-input');
        let val = parseInt(input.value) || 1;
        if (btn.classList.contains('qty-minus') && val > 1) val--;
        if (btn.classList.contains('qty-plus')) val++;
        input.value = val;
      });
    });

    // Variant change update hidden id if needed (for non-select id)
    form.querySelector('.variant-select')?.addEventListener('change', e => {
      form.querySelector('.variant-id').value = e.target.value;
    });
  });
});
document.addEventListener('DOMContentLoaded', function() {
  // AJAX Add to Cart
  document.querySelectorAll('.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.add-cart-btn');
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!response.ok) throw new Error('Failed to add');
        
        // Open drawer
        const drawer = document.querySelector('details[open] cart-drawer') || document.querySelector('cart-drawer');
        if (drawer) {
          drawer.open = true;
          // Update drawer content
          const sectionId = drawer.dataset.sectionId || 'cart-drawer';
          fetch(`${window.location.pathname}?section_id=${sectionId}`)
            .then(res => res.text())
            .then(html => {
              const newDrawer = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
              drawer.replaceWith(newDrawer);
            });
        }

        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      } catch (error) {
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }
    });

    // Quantity buttons
    form.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = form.querySelector('.qty-input');
        let value = parseInt(input.value) || 1;
        if (btn.classList.contains('qty-minus') && value > 1) value--;
        if (btn.classList.contains('qty-plus')) value++;
        input.value = value;
      });
    });
  });

  // Fix drawer close (listen for clicks outside or ESC)
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('cart-drawer__backdrop') || e.target.closest('.cart-drawer__close')) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open = false;
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open = false;
    }
  });
});